import React, { useState } from 'react';
import { useData } from '../../data/DataProvider';
import { useToast } from '../../shared/components/ToastProvider';
import { portalApi } from '../../lib/api';

// "Portal access" (auth_magic_link_spec.md §6) — replaces the old
// copy/regenerate portal-link UI. Each row sends a fresh 10-minute OTP
// email to the client; the linked account is auto-created on first send.
export default function PortalLinks() {
  const { data } = useData();
  const { notify } = useToast();
  const [busyId, setBusyId] = useState(null);

  const resend = async (client) => {
    setBusyId(client.id);
    try {
      const result = await portalApi.sendPortalAccess(client.id);
      notify(`Sign-in link sent to ${result.email || client.email}`);
    } catch (err) {
      notify(err.message || 'Failed to send access email', 'error');
    } finally {
      setBusyId(null);
    }
  };

  const rows = [...(data.clients || [])].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <section className="panel settings-form">
      <h3>Portal access</h3>
      <p className="field-hint">
        Email a client a one-click sign-in link (valid 10 minutes). Sessions last
        30 days, so links are only needed when one expires or the client logs out.
      </p>
      {rows.map((client) => (
        <div className="config-row" key={client.id}>
          <strong>{client.name}</strong>
          <span className="field-hint">{client.email || 'no email set'}</span>
          <button
            className="primary-button"
            disabled={busyId === client.id || !client.email}
            onClick={() => resend(client)}
          >
            {busyId === client.id ? 'Sending…' : 'Resend access'}
          </button>
        </div>
      ))}
    </section>
  );
}
